import { spawn, takeLatest, put } from 'redux-saga/effects';

// Actions
import { casoBordeActions } from '../../../../application/actions/casoBordes';


export function* fetchCasoBorde(props) {
    const { payload } = props;
    yield put(casoBordeActions.casoBordeStatus({ estado: payload }));
}

export function* watchFetchCasoBorde() {
  yield takeLatest(casoBordeActions.casoBordes.type, fetchCasoBorde);
}

export default function* rootSaga() {
  yield spawn(watchFetchCasoBorde);
}
